import { _ } from "libs";
import React, { FC, memo, useContext, useEffect, useState } from "react";
import { Championship, ChampionshipChallenge, Player } from "../../types";
import {
	getChampionshipSuggestions,
	loadLeaderboardFirstPage,
	openPlayerPopup,
	reloadMyChampionships,
} from "../../actions";
import PlayerItemMedium from "../items/player/medium";
import { formatUserName } from "../../libs/formatName";
import Loader from "../loader";
import ChampionshipContext from "../../contexts/championshipContext";

type OpponentsProps = {
	children?;
	onInvitePressed?;
};

const OpponentSuggestions: FC<OpponentsProps> = ({ children, onInvitePressed }: OpponentsProps) => {
	const { championship } = useContext(ChampionshipContext);

	const [suggestions, setSuggestions] = useState(null as Player[]);
	const [loading, setLoading] = useState(true);

	const reloadSuggestions = async () => {
		const suggestions = await getChampionshipSuggestions(championship.uuid, 0, 3);
		setSuggestions(suggestions);
	};

	if (championship.settings?.trial?.hasExpiredTrial) {
		return null;
	}

	useEffect(() => {
		let unmounted = false;

		if (!unmounted) {
			if (championship && championship?.optedIn) {
				setLoading(true);
				reloadSuggestions();
				setLoading(false);
			}
		}

		return () => {
			unmounted = true;
		};
	}, [championship]);

	return (
		<>
			{championship && championship?.optedIn ? (
				<div className="nBlock">
					<h5>{_("championship.suggestedOpponents.heading")}</h5>
					{!loading && suggestions?.length > 0 && (
						<div className="table looseSpacing">
							{suggestions.map((player, i) => {
								let pointsToWin = (
									<div className="badge primary">
										{!player.winPoints
											? _("championship.challengeToWinNoPoints")
											: _("championship.challengeToWinPoints", null, {
													points: player.winPoints,
											  })}
									</div>
								);
								return (
									<div
										className="cell clickable"
										onClick={() =>
											openPlayerPopup(player.playerId, true, {
												championshipName: championship.name,
											})
										}
										key={["suggestion_player", i].join("_")}
									>
										<PlayerItemMedium
											name={formatUserName(player)}
											meta={pointsToWin}
											photoUrl={player.photoUrl}
										/>
									</div>
								);
							})}
						</div>
					)}
					{championship.settings.showInvite && onInvitePressed && (
						<div className="mt-4">
							<div className="button secondaryButton" onClick={onInvitePressed}>
								{_("championship.inviteBtn")}
							</div>
						</div>
					)}
				</div>
			) : null}
			{!loading && championship && championship?.optedIn && suggestions && suggestions.length === 0 && children}
			{loading && <Loader notext={true} />}
		</>
	);
};

export default memo(OpponentSuggestions);
